export default __webpack_public_path__ + "media/images/icons/arrow-blue-next-7bea0dc54ca20d145d53675a7c9634bd.png";